/**
 * Global functions live here.
 */


/**
 * Toggle multiple classes
 */

export function toggleClasses(selector, classes) {
  selector = selector || '';
  classes = classes || '';
  if (
    typeof selector == 'string'
    &&
    (typeof classes == 'string' || Array.isArray(classes))
    &&
    classes.length // true if either string or array not empty
    &&
    (selector = document.querySelector(selector))
  ) {
    var classList = selector.classList;
    if (!Array.isArray(classes)) {
      classes = classes.replace(/(,\s*|\s+)/g, ' ').split(' ');
    }
    for (var className of classes) {
      classList.toggle(className);
    }
    return true;
  }
}


/**
 * Change menu items to white if video or hero present
 */
export function menuWhiteout() {
  //This is also inlined in the hero and video blocks to apply styling on load.
  const header = document.getElementById('header');
  const section = document.querySelector('section');
  if (section.classList.contains('fullscreen-video') || section.classList.contains('hero')) {
    header.classList.add('whiteOut', '1024:bg-transparent');
    if (window.innerWidth < 1024) {
      let headerHeight = document.getElementById('header').offsetHeight;
      document.getElementById('main').style.cssText = 'margin-top: '+ headerHeight+'px!important;';
    }
    else {
      document.getElementById('main').style.cssText = 'margin-top: 0!important;';
    }
  }
}

/**
 * Cookies get, set and delete
 */

export function setCookie(name, value, days) {
  let d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

export function getCookie(name) {
  let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

export function deleteCookie(name) { setCookie(name, '', -1); }


/**
 * Get siblings
 */

export function getSiblings(elem) {
  return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
    return sibling !== elem;
  });
}
